import Service from "./Service";
const baseurl = '/api/historia-motivo';
export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    showByHc(id) {
        return Service.get(`${baseurl}/show-by-hc/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    showMotivoByHc(id_historia) {
        return Service.get(`${baseurl}/show-motivo-hc/${id_historia}`);
    },
}